module.exports = __webpack_public_path__ + "static/media/plan-B5c-desktop-en.bf26f2b6.png";